import api from "./api";

export const patchMyVenue = async (body) => {
  return api
    .patch({
      body,
      endpoint: "/own/my-venue",
      port: process.env.REACT_APP_PORT_VENUE,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
